import { connect } from 'react-redux'
import UI from './UI'

const mapStateToProps = ({ learningPath }) => ({
  Duration: learningPath.LearningPath.Duration,
  TotalCourses: learningPath.LearningPath.CountCourses
})

export default connect(mapStateToProps, null)(UI)
